import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';

export default class InfoPopUp extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, infoName)
    {
        super(scene);

        console.log(infoName);
        this.name = infoName.toLowerCase();

        if(this.scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS).has(this.name+"info")) this.infoClip = ABCyaPhaser.Images.addImage(0, 0, this.name + "info", this).setOrigin(0);

        let data;
        if(infoName === "HEADING"){
          data = {
            size_title: 32,
            size_body: 32,
            titleY: 10,
            bodyY: 60,
            spacing: 0,
            width:this.infoClip.width - 30,
            string: this.name
          }
        };
        if(infoName === "SALUTATION"){
          data = {
            size_title: 32,
            size_body: 30,
            titleY: 12,
            bodyY: 84,
            spacing: -1,
            width:this.infoClip.width - 40,
            string: "salutation_greeting"
          }
        };
        if(infoName === "BODY"){
          data = {
            size_title: 32,
            size_body: 32,
            titleY: 12,
            bodyY: 50,
            spacing: -2,
            width:this.infoClip.width - 30,
            string: this.name
          }
        };
        if(infoName === "CLOSING"){
          data = {
            size_title: 32,
            size_body: 32,
            titleY: 10,
            bodyY: 50,
            spacing: -4,
            width:this.infoClip.width - 30,
            string: this.name
          }
        };
        if(infoName === "SIGNATURE"){
          data = {
            size_title: 32,
            size_body: 28,
            titleY: 10,
            bodyY: 53,
            spacing: -2,
            width:this.infoClip.width - 10,
            string: this.name
          }
        };
        
        this.titleTxt = ABCyaPhaser.Text.addText(25, data.titleY, data.size_title, 0x3358a8, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("letter." + data.string), this, false).setResolution(1.5).setWordWrapWidth(data.width);
        this.bodyTxt = ABCyaPhaser.Text.addText(25, data.bodyY, data.size_body, 0x231f20, FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString("letter." + this.name + "_body").toUpperCase(), this, false).setResolution(1.5).setWordWrapWidth(data.width).setLineSpacing(data.spacing);
        if(infoName === "BODY") {
          ABCyaPhaser.Text.resizeFontToFitWidth(this.bodyTxt, 300, 140);
        }
        if(infoName === "CLOSING") ABCyaPhaser.Text.addText(25, 250, 18, 0x231f20, FontKeys._asapregular, ABCyaPhaser.Localization.instance.getLocalizedString("letter." + this.name + "_footer"), this, false).setResolution(1.5).setWordWrapWidth(data.width).setLineSpacing(data.spacing);
        
        this.alpha = 0;
    }

    showPart()
    {
        ABCyaPhaser.Tweens.addTween(this, 400, { alpha: 1, scale: {start: 0, to: 1} }, Phaser.Math.Easing.Quadratic.Out);
    }
}